<!-- 定时开关机设置 -->
<template>
  <div class="campus-announcement">
    <div class="timeSwitch">
      <div class="switchBox">
        <div class="time-box">
          <span class="time-right">开机时间</span>
          <span class="time-left">关机时间</span>
        </div>
        <div class="time-input">
          <input v-model="Dvalue.powerOnTime" type="text" class="input-left">
          <input v-model="Dvalue.powerOffTime" type="text" class="input-right">
        </div>
      </div>
      <div class="timeFormat">时间格式：HH:MM 例如：10：30</div>
      <el-button class="buttonSave" @click="timeUpdateClick">保存设置</el-button>
    
    </div>
  </div>
</template>

<script>
import { timeSwitchFind ,
        timeSwitchUpdate
} from '@/assets/api/logapi';
export default {
  components: {
  }, 
  data() {
      return {
        Dvalue:{
        powerOnTime:'',
        powerOffTime:""
       }
      };
  },
  created() {
    this.timeSwitchSearch()
    
  },
  mounted() {
  },
  methods: {
    timeSwitchSearch(){
      const params = {userId:JSON.parse(localStorage.getItem('user')).id}
      // 查询请求
      timeSwitchFind(params).then((res)=> {
                    console.log(res,'定时开关机接口');
                    this.Dvalue = res.data.data
                }).catch((err)=> {
                    console.log(err,'定时来发接口');
                })
    },
    //保存
    timeUpdateClick(){
      console.log(1);
      const params = {
        userId:JSON.parse(localStorage.getItem('user')).id,
        powerOnTime:this.Dvalue.powerOnTime,
        powerOffTime:this.Dvalue.powerOffTime
      }
      timeSwitchUpdate(params).then((res)=> {
        this.$message({
              type: 'success',
              message: '保存成功!'
            });
        console.log(res,'保存成功');
      
      }).catch((err) => {
          console.log('保存失败',err);
      })


    }


  },
};
</script>

<style scoped lang="scss">
.campus-announcement {
  height: 95%;
  background-color: #fff;
  padding-top: 20px;
  .timeSwitch{
    // margin-top: 50px;
    height: 300px;
    width: 50%;
    margin:  0 auto;

    // background: pink
    ;
    border: 0.5px solid #ccc;
    .switchBox{
      height: 100px;
      width:600px ;
      border: 0.5px solid #ccc;
      margin-left:105px;
      // background: greenyellow;
      margin-top: 40px;
   
      .time-box{
        padding-top: 20px;
        display: flex;
        justify-content: space-around;
        border-bottom:1px solid #ccc ;
        height: 50px;
      }
      .time-input {
        display: flex;
        justify-content: space-around;
      }
      
      .time-input input {
        border: 1px solid gray;
        margin-top: 10px;
  
      }
      .input-left{
        margin-right: 120px;
        margin-left: 60px;
      }

      

      // .time-left{
        
      // }
    }
    .timeFormat{
        margin-top: 10px;
        margin-left: 370px;
        font-size: 14px;
        color: gray;
      }
    .buttonSave{
      height: 30px;
      margin-top: 20px;
      margin-left: 380px;
      border: 1px solid gray;
    }
    
  }
}
</style>
